import React from "react"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

const Breadcrumbs = ({ crumbs, label }) => (
  <Breadcrumb crumbs={crumbs} crumbSeparator={" "} crumbLabel={label} />
)

export default Breadcrumbs
